import ListItemText from "@mui/material/ListItemText"
import { useContext } from "react"
import { MapContext } from "../../../MapContextProvider"
import { StyledTypographyLarge, StyledTypographyMedium } from "./DeviceLabel.styled"

const DeviceLabel = ({ device }) => {
  const { onDeviceListLabelClick } = useContext(MapContext)

  return (
    <ListItemText
      onClick={() => {
        onDeviceListLabelClick(device)
      }}>
      <StyledTypographyLarge color="primary" variant="paragraphLarge">
        {device.internalDeviceId}
      </StyledTypographyLarge>
      <StyledTypographyMedium variant="paragraphMedium">{device.label}</StyledTypographyMedium>
    </ListItemText>
  )
}

export default DeviceLabel
